export default {
    link: {
        color: '#000'
    },
    boldLink: {
        color: '#000',
        fontWeight: 'var(--e-global-typography-primary-font-weight)'
    },
    savedCardHeader: {
        background: 'var(--e-global-color-accent)',
        color: 'var(--e-global-color-primary)'
    },
    savedCard: {
        background: '#f0f0f0'
    }
};
